import { CloseOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { Button } from 'finara-components';
import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  variant?: 'danger' | 'warning' | 'info';
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false,
  variant = 'warning',
}) => {
  if (!isOpen) return null;

  const iconColor = variant === 'danger' ? 'text-red-600' : variant === 'warning' ? 'text-yellow-600' : 'text-blue-600';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black opacity-60 transition-opacity"
        onClick={onClose}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Escape') onClose();
        }}
        aria-label="Cerrar modal"
      />

      {/* Modal */}
      <div className="relative bg-surface rounded-lg shadow-xl max-w-md w-full mx-4 p-6 z-10 border border-border">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted hover:text-brand-white transition-colors"
          disabled={isLoading}
        >
          <CloseOutlined fontSize="small" />
        </button>

        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-white/10">
          <WarningAmberOutlined className={iconColor} />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-brand-white text-center mb-2">
          {title}
        </h3>

        {/* Message */}
        <p className="text-sm text-muted text-center mb-6">
          {message}
        </p>

        {/* Actions */}
        <div className="flex gap-3">
          <Button
            variant="white"
            onClick={onClose}
            disabled={isLoading}
            className="flex-1"
          >
            {cancelText}
          </Button>
          <Button
            variant="black"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1"
          >
            {isLoading ? 'Procesando...' : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};
